import axios from "axios";
import configData from "../../config/config.json";
import AjaxResponseHandler from "../../utils/AjaxResponseHandler"

const handleLandNotifcationConfigResults = (dispatch, results) => {
  results.namedContentResultList.forEach((result) => {
    dispatch({ type: result.name, results: result.baseContent });
  });
};

export const getLandNotificationConfig = () => async dispatch => {
  await axios.get(configData.LANDNOTIFICATION_SERVER_URL + "helperdata/landnotification")
    .then(
      (response) => { handleLandNotifcationConfigResults(dispatch, response.data.content); },
      (error) => { console.log(error); }
    );
};

export const getServerProductVersions = () => async dispatch => {
  await axios.get(configData.LANDNOTIFICATION_SERVER_URL + "helperdata/productVersions")
    .then(
      (response) => {dispatch({type: 'SERVER_PRODUCT_VERSIONS' , result: response.data.content}) },
      (error) => { console.log(error); }
    );
};

const handleLandNotificationConfigCodeDescriptionResults = (dispatch, results) => {
  results.namedCodeDescriptionResultList.forEach((result) => {
    dispatch({ type: result.name, results: result.codeDescriptionResults })
  }
  );
};

export const bootstrap = (afterFunction) => {
  let request = {};

  // Form the URL from the current page URL.
  console.log('bootstrapping');
  console.log("PUBLIC_URL [" + window.trimin.PUBLIC_URL + "]");

  let url = window.trimin.PUBLIC_URL + "/landnotificationui/product.json";

  console.log("loading configuration from " + url);

  return (axios.get(url, request, { withCredentials: true })
      .then((response) => {
        const content = response.data;

        console.log("configuration:");
        console.log(content);

        configData.BROWSER_ROUTER_BASENAME = content.BROWSER_ROUTER_BASENAME;
        configData.LANDNOTIFICATION_SERVER_URL = content.LANDNOTIFICATION_SERVER_URL;        

        console.log("final configuration");
        console.log(configData);

        if (afterFunction) afterFunction();
      }, (error) => {
        AjaxResponseHandler.handleError(error, AjaxResponseHandler.consoleLogHandler);

        console.log("**********************************");
        console.log("**** CANNOT LOAD CONFIGURATION ***");
        console.log("**********************************");

        if (afterFunction) afterFunction();
      })
  );
}

export const getLandNotificationCodeDescriptionConfig = () => async dispatch => {
  await axios.get(configData.LANDNOTIFICATION_SERVER_URL + "helperdata/landnotificationcodedescription")
    .then(
      (response) => { handleLandNotificationConfigCodeDescriptionResults(dispatch, response.data.content); },
      (error) => { console.log(error); }
    );
};
